import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

interface ProductWeightProps {
  productSize?: string;
}

// #region styles
const Container = styled.div`
  align-items: center;
  display: flex;
  gap: 0.25rem;
  font-size: 0.7rem;
  font-weight: ${Styles.fontWeight.heavy};
  margin-block-start: 3px;
`;

const WeightLabel = styled.span`
  margin: 0;
  font-weight: ${Styles.fontWeight.heavy};
`;

const WeightValue = styled.span`
  font-weight: ${Styles.fontWeight.normal};
`;
// #endregion

export const ProductWeight: React.FC<ProductWeightProps> = ({ productSize }) => {
  const { formatMessage } = useIntl();

  if (!productSize) {
    return null;
  }

  return (
    <Container data-testid="product-weight">
      <WeightLabel>{formatMessage({ id: 'productSizeNutritionLabel' })}: </WeightLabel>
      <WeightValue>{productSize}</WeightValue>
    </Container>
  );
};
